import React from 'react';
import './Innovation.css';
import ScrollAnimation from 'react-animate-on-scroll';
import iconTechnology from './images/technology.svg';
import iconVenture from './images/venture.svg';

const Innovation = () => {

    return (
        <section className="innovation hero-triangle">
            <div className="hero-body">
                <div className="container">
                    <div className="columns is-multiline">
                        <div className="column is-offset-1-tablet is-10-tablet is-11-desktop is-10-widescreen">
                            {/* <ScrollAnimation
                            duration={0.65}
                            animateOnce={true}
                            animateIn='fadeInLeft'
                            delay={75}
                            initiallyVisible={false}> */}
                                <div className="title-wrapper ">
                                    <div className="big-title">INNOVATION AT HUDSON PACIFIC</div>
                                </div>
                                <div className='description'>
                                    We’re ahead of the curve in leveraging technology to elevate our world-class properties. We prioritize technologies that enhance or create new revenue streams, drive cost savings quickly, solve major pain points in how we run our buildings or company, advance our Better Blueprint program, and differentiate us from the crowd.
                                </div>
                            {/* </ScrollAnimation> */}
                            <div className="columns is-multiline">
                                <div className="column is-12-tablet is-6-desktop padding-right-desktop">
                                    <div className="iconix">
                                        <img src={iconTechnology} alt={'TECHNOLOGY DEPLOYMENT'} />
                                    </div>
                                    <div className="internal-title">TECHNOLOGY DEPLOYMENT</div>
                                    <div className="divider">
                                        <hr></hr>
                                    </div>
                                    <div className='internal-description'>
                                     We’ve rolled out technologies at scale, like energy monitoring and leak detection, and piloted others we find promising, like AI-enabled analysis and tools.
                                    </div>
                                </div>
                                <div className="column is-12-tablet is-6-desktop padding-left-desktop">
                                    <div className="iconix">
                                        <img src={iconVenture} alt={'VENTURE INVESTING'} />
                                    </div>
                                    <div className="internal-title">VENTURE INVESTING</div>
                                    <div className="divider">
                                        <hr></hr>
                                    </div>
                                    <div className='internal-description'>
                                    Sometimes the tech we need does not exist, and we fund development ourselves—primarily by investing in third-party venture funds, like proptech-focused Fifth Wall. 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Innovation;
